import React from "react";

const CouponAnalytics = ({ coupon }) => {

    if (!coupon) return null;

    const usage = coupon.usageLimit
        ? Math.round((coupon.usedCount / coupon.usageLimit) * 100)
        : 0;

    return (
        <div className="coupon-analytics">

            <h3>Coupon Analytics</h3>

            <div className="analytics-grid">

                <div className="analytics-card">
                    <h4>Total Uses</h4>
                    <h2>{coupon.usedCount}</h2>
                </div>

                <div className="analytics-card">
                    <h4>Usage Limit</h4>
                    <h2>{coupon.usageLimit}</h2>
                </div>

                <div className="analytics-card">
                    <h4>Remaining</h4>
                    <h2>{coupon.usageLimit - coupon.usedCount}</h2>
                </div>

                <div className="analytics-card">
                    <h4>Usage</h4>

                    <div className="progress">
                        <div
                            className="progress-fill"
                            style={{
                                width: `${usage}%`,
                            }}
                        />
                    </div>

                    <p>{usage}% Used</p>

                </div>

            </div>

        </div>
    );
};

export default CouponAnalytics;